import {type Locale} from 'localization/types';
import type {Schemas} from 'api/dto.generated';
import {ebsApi} from 'store/ebsApi';
import type {
  Thesaurus,
  ThesaurusId,
  ThesaurusNode,
  ThesaurusNodeDto,
} from './types';
import {mapGrepExtendedConceptDto} from './mappers/mapGrepExtendedConceptDto';
import {mapThesaurusDto} from './mappers/mapThesaurusDto';

const thesaurusApi = ebsApi.injectEndpoints({
  endpoints: build => ({
    getThesaurus: build.query<
      Thesaurus,
      {
        id: ThesaurusId;
        language: Locale;
      },
      ThesaurusNodeDto[]
    >({
      keepUnusedDataFor: 60,
      query: ({id}) => ({
        url: `thesaurus/${id}/export`,
      }),
      transformResponse: (response, _, {id, language}) =>
        mapThesaurusDto(response, id, language),
    }),
    getGrepNodeDetails: build.query<
      ThesaurusNode,
      string,
      Schemas.GrepExtendedConcept
    >({
      keepUnusedDataFor: 60,
      query: code => ({
        url: `thesaurus/grep/${code}`,
      }),
      transformResponse: (response, _, code) =>
        mapGrepExtendedConceptDto(code, response),
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetThesaurusQuery,
  useGetGrepNodeDetailsQuery,
  useLazyGetGrepNodeDetailsQuery,
} = thesaurusApi;
